import {Button} from '@/components/ui/button/Button'
import {
    DialogBody,
    DialogDismiss,
    DialogFooter,
    DialogHeader,
    DialogHeading
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useTranslation} from '@/translations/i18n'
import {FallbackProps} from 'react-error-boundary'
import {AccordionError} from '@/components/commons/accordion-error/AccordionError'

interface AgendaEventDetailsErrorDialogProps extends Partial<Pick<FallbackProps, 'error'>> {
    refetch: () => void
    isFetching: boolean
}

export const AgendaEventDetailsErrorDialog = ({error, refetch, isFetching}: AgendaEventDetailsErrorDialogProps) => {
    const {t} = useTranslation()

    return (
        <>
            <DialogHeader>
                <DialogHeading>{t('errors:default')}</DialogHeading>
                <DialogDismiss />
            </DialogHeader>
            <DialogBody>
                <AccordionError title={t('agenda:impossible_to_fetch_event')} description={error.message} />
            </DialogBody>
            <DialogFooter>
                <Flexbox fullWidth justify="end" gap={2}>
                    <DialogDismiss
                        render={props => (
                            <Button variant="secondary" {...props}>
                                {t('commons:close')}
                            </Button>
                        )}
                    />
                    <Button variant="primaryNeutral" onClick={refetch} disabled={isFetching}>
                        {isFetching && <Spinner size={16} />}
                        {t('commons:retry')}
                    </Button>
                </Flexbox>
            </DialogFooter>
        </>
    )
}
